module.exports = __webpack_public_path__ + "img/11.af536d49.png";